var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShoppingBag(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_230_10234)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.375 4.5C13.375 2.01871 11.3563 0 8.875 0C6.39367 0 4.375 2.01871 4.375 4.5H1V15.1875C1 16.7408 2.25919 18 3.8125 18H13.9375C15.4908 18 16.75 16.7408 16.75 15.1875V4.5H13.375ZM8.875 1.125C10.736 1.125 12.25 2.639 12.25 4.5H5.5C5.5 2.639 7.014 1.125 8.875 1.125ZM15.625 15.1875C15.625 16.118 14.868 16.875 13.9375 16.875H3.8125C2.88202 16.875 2.125 16.118 2.125 15.1875V5.625H4.375V7.3125C4.375 7.62318 4.62686 7.875 4.9375 7.875C5.24814 7.875 5.5 7.62318 5.5 7.3125V5.625H12.25V7.3125C12.25 7.62318 12.5018 7.875 12.8125 7.875C13.1232 7.875 13.375 7.62318 13.375 7.3125V5.625H15.625V15.1875Z",
    fill: "#B1BAD1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_230_10234"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 18,
    fill: "white",
    transform: "translate(1)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingBag);
export default __webpack_public_path__ + "static/media/shopping-bag.86e523f515a65289cc27b57b29f011d8.svg";
export { ForwardRef as ReactComponent };